/**
 * https://www.figma.com/file/D2uWFGX4XBbzDlYYlxKnzs/Karius-Design-Language?type=design&node-id=1367-234&mode=design&t=rNSmf0lvfidgFNc6-0
 * 👍 These should be used to map colors to tokens in the theme
 * 🙅‍♂️ These should not be used directly in the app, use tokens from the theme
 */
export const colorPalette = {
    Blue50: '#F0F5FF',
    Blue200: '#A3B0D0',
    Blue600: '#404C73',
    Blue800: '#212944',
    Grey50: '#F5F5F5',
    Grey100: '#D7DADA',
    Grey300: '#9EA1A5',
    Grey500: '#747577',
    Grey600: '#5E5F61',
    Mint50: '#E6FFF9',
    Mint200: '#65CCB8',
    Mint600: '#086654',
    Orange50: '#FFECE6',
    Orange200: '#F99F7A',
    Orange500: '#CC4E13',
    Orange600: '#A63907',
    Teal50: '#E6FFFF',
    Teal300: '#11A8A7',
    Teal500: '#0D7479',
    Teal500Light: '#E7F1F2',
    Teal600: '#0D5C61',
    White: '#FFFFFF',
    Yellow50: '#FFF9E6',
    Yellow200: '#CFB96E',
    Yellow600: '#6F560A',
};
